"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseInfo = _interopRequireDefault(require("./components/baseInfo"));
var _gridMenu = _interopRequireDefault(require("./components/gridMenu"));
var _visitChart = _interopRequireDefault(require("./components/visitChart"));
var _userChart = _interopRequireDefault(require("./components/userChart"));
var _userOverview = _interopRequireDefault(require("./components/userOverview"));
var _userFuka = _interopRequireDefault(require("./components/userFuka"));
var _permission = require("@/utils/permission");
var _authInformation = require("@/api/authInformation");
var _systemConfig = require("@/api/systemConfig");
var _cache = _interopRequireDefault(require("@/plugins/cache"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'Dashboard',
  components: {
    baseInfo: _baseInfo.default,
    gridMenu: _gridMenu.default,
    visitChart: _visitChart.default,
    userChart: _userChart.default,
    userOverview: _userOverview.default,
    userFuka: _userFuka.default
  },
  data: function data() {
    return {
      authStatus: null,
      authHost: '',
      authQueryStatus: false,
      notInformation: null,
      homeType: false,
      miniProgramCustomer: false,
      defaultCustomerId: null
    };
  },
  created: function created() {
    var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    this.defaultCustomerId = JavaInfo.customerId;
    console.log(JavaInfo.homeType);
    this.homeType = JavaInfo.homeType === 2; //2为普通用户  1为管理员  5为小程序客户
    this.miniProgramCustomer = JavaInfo.type === 5;
    console.log(this.homeType);
  },
  mounted: function mounted() {
    if (window.location.host.indexOf('localhost') == -1) {
      this.authStatus = _cache.default.local.has('auth-information') ? _cache.default.local.getJSON('auth-information') : null;
      this.notInformation = _cache.default.local.has('not-information') ? _cache.default.local.getJSON('not-information') : null;
      if (!this.authStatus) {
        this.getUniq();
      }
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    authInformationQuery: function authInformationQuery() {
      var _this = this;
      (0, _authInformation.authCertQuery)({
        host: this.authHost
      }).then(function (res) {
        var oneDay = 24 * 3600 * 1000;
        if (res.data.status == -1 || res.data.status == 2) {
          _cache.default.local.setItem({
            name: 'not-information',
            value: true,
            expires: oneDay
          });
          if (!notInformation) {
            _this.$modal.confirm(res.data.msg).then(function () {
              _this.$router.push({
                path: '/maintain/authCRMEB'
              });
            }).catch(function () {});
          }
        } else if (res.data.status == 1) {
          _this.$modal.msgSuccess(res.data.msg);
          _cache.default.local.setItem({
            name: 'auth-information',
            value: true,
            expires: oneDay * 7
          });
        } else if (res.data.status == 3 || res.data.status == 0) {
          _this.$modal.msg(res.data.msg);
        }
      });
    },
    getUniq: function getUniq() {
      var _this2 = this;
      (0, _systemConfig.getAuthHostApi)({
        key: 'authHost'
      }).then(function (res) {
        _this2.authHost = res.value;
        if (res.value !== '') {
          _this2.authInformationQuery();
        } else {
          _this2.$modal.confirm('您尚未提交授权申请').then(function () {
            _this2.$router.push({
              path: '/maintain/authCRMEB'
            });
          });
        }
      });
    }
  }
};